$('.brands-slider').slick({
  dots: true,
  infinite: true,
  arrow: false,
  speed: 300,
  autoplay: true,
  slidesToShow: 6,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
         arrow: false,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
         arrow: false,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
 setTimeout(function () {
      $('#recently-viewed-products1').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        arrows: true,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });
    }, 2000); // 1000ms (1 second) delay before initializing


document.addEventListener("DOMContentLoaded", function () {
  var countElement = document.querySelector(".wish_bubble");
  var count = parseInt(countElement.textContent.trim()) || 0;
  var countIdElement = document.querySelector("#wish_bubble_hidden");
  var hiddenCount = parseInt(countElement.textContent.trim()) || 0;
  document.querySelectorAll(".wishlist-btn").forEach(button => {
    button.addEventListener("click", async function () {
      const productId = this.dataset.productId;
      const customerId = this.dataset.customerId;
      const isRemoving = this.classList.contains("remove");
      const url = isRemoving ? "/wishlist/remove" : "/wishlist/add";

      // Add loading effect
      this.classList.add("loading");

      try {
        const response = await fetch("https://wishlist-app-arjen-f8e5b84055d3.herokuapp.com" + url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customer_id: customerId, product_id: productId, shop: "barberbrandseurope-shop.myshopify.com" })
        });
        console.log(JSON.stringify({customer_id: customerId, product_id: productId, shop: "barberbrandseurope-shop.myshopify.com"}));
        
        const data = await response.json();                
        // console.log(data);

        if (data.success) {
          let oldNumber = Number(document.getElementById('wish_bubble_hidden').innerHTML);
          console.log("oldNumber",oldNumber);
          console.log(typeof(oldnumber));

          let newNumber = isRemoving ? oldNumber - 1 : oldNumber + 1;
          console.log("newNumber",newNumber);
          console.log(typeof(newNumber));
          document.getElementById('wish_bubble_hidden').innerHTML = newNumber;
          const editedNumber = newNumber > 9 ? '9+' : newNumber;
          document.getElementById('wish_bubble').innerHTML = editedNumber;

          // Toggle button UI
          this.innerHTML = isRemoving
          ? '<span>❤ Favorite</span>'
          : '<span>Remove Favorite</span>';
          this.classList.toggle("remove");
          this.classList.toggle("add");
          // if (url == "/wishlist/add") {
          //   count += 1;
          //   countElement.textContent = count;
          //   countIdElement.textContent = count;
          //   console.log(count);
          //   console.log(countIdElement.textContent);
          // }
          // if (url == "/wishlist/remove") {
          //   count -= 1;
          //   countElement.textContent = count;
          //   countIdElement.textContent = count;
          //   console.log(count);
          //   console.log(countIdElement.textContent);
          // }
        } else {
          alert("Error: " + data.error);
        }
        
        // let arrayToCheck = [];
        // if (data.tags && Array.isArray(data.tags)) {
          //   arrayToCheck = data.tags;
          // } else {
            //   console.warn("Items array not found in response data");
            // }
            
            // const wCount = arrayToCheck.filter(item => item.startsWith("w_")).length;
            // console.log("Count of items starting with 'w_':", wCount);
            
        } catch (error) {
          alert("Something went wrong. Please try again.");
        } finally {
          // Remove loading effect
          this.classList.remove("loading");
        }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.hash) {
    scrollToWithOffset(window.location.hash);
  }
});

window.addEventListener("hashchange", () => {
  scrollToWithOffset(window.location.hash);
});

function scrollToWithOffset(hash) {
  const id = hash.replace("#", "");
  const element = document.getElementById(id);

  if (element) {
    const yOffset = -180;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

window.addEventListener("load", () => {
  if (window.location.hash) {
    const id = window.location.hash.substring(1);
    const element = document.getElementById(id);
    if (element) {
      const offset = 180;

      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
});

// CUSTOM CODE TO UPDATE THE BUBBLE COUNT FOR WISHLIST 
// let dyCount = document.querySelector(".wish_bubble").innerHTML;
// console.log(dyCount);

// let tagArr = [];
// if (window.CustomerData && window.CustomerData.isLoggedIn === 'true') {
//   const tags = window.CustomerData.tags;
//   console.log('Customer Tags:', tags);

//   for (tagArr)
// }

// document.querySelectorAll(".wishlist-btn").forEach((buttons) => {
//   buttons.addEventListener("click", (button) => {
//     if (dyCount )
//   })
// })

